export default ['arboristLogin', 'client','property','report', 'tree', 'arbor']